import { createBrowserRouter, createMemoryRouter } from 'react-router'
import { IS_INTEGRATED_VERSION } from '../config/ConfigManager'
import { routeData } from '../main/router/routes'
import {
  wrapCreateBrowserRouterV7,
  wrapCreateMemoryRouterV7,
} from '@sentry/react'

// https://docs.sentry.io/platforms/javascript/guides/react/features/react-router/v7/#usage-with-createbrowserrouter-or-creatememoryrouter-data-mode
const sentryCreateBrowserRouter = wrapCreateBrowserRouterV7(createBrowserRouter)
const sentryCreateMemoryRouter = wrapCreateMemoryRouterV7(createMemoryRouter)

/**
 * AES is served in a single page and the url never changes.
 * COSTAR is injecting a script into the page whenever the page loading state changes.
 * So multiple copies of a script are being injected into the dom and multple event listeners are created as the user navigates the page in V3 as it is a SPA.
 * Using memory history fixes this as the url and the page state never changes.
 */
const createRouter = IS_INTEGRATED_VERSION
  ? sentryCreateMemoryRouter
  : sentryCreateBrowserRouter

export default createRouter(routeData)
